import React, { useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./pickup-queue.scss";

const initialPickupOrders = [
  {
    orderNo: "SB-10084",
    customer: "Channie",
    phone: "012-3456789",
    status: "Paid",
    pickupTime: "Today, 6:30 PM",
    amount: "RM18.90",
    productName: "Chicken Katsu Bento",
    quantity: 1,
    note: "Customer will collect before 6:45 PM.",
  },
  {
    orderNo: "SB-10083",
    customer: "Daniel",
    phone: "011-2233445",
    status: "Paid",
    pickupTime: "Today, 7:00 PM",
    amount: "RM12.50",
    productName: "Healthy Rice Bowl",
    quantity: 1,
    note: "No cutlery needed.",
  },
  {
    orderNo: "SB-10086",
    customer: "Mei Ling",
    phone: "016-9988776",
    status: "Collectible",
    pickupTime: "Today, 7:15 PM",
    amount: "RM22.80",
    productName: "Chicken Rice Bowl",
    quantity: 2,
    note: "Less spicy.",
  },
];


const PickupQueuePage = () => {
  const navigate = useNavigate();
  const [keyword, setKeyword] = useState("");
  const [orders, setOrders] = useState(initialPickupOrders);
  const [confirmOrder, setConfirmOrder] = useState(null);

  const filteredOrders = useMemo(() => {
    const search = keyword.trim().toLowerCase();
    if (!search) return orders;

    return orders.filter((order) =>
      `${order.orderNo} ${order.customer} ${order.phone} ${order.productName}`.toLowerCase().includes(search)
    );
  }, [keyword, orders]);

  const handleConfirmCollected = () => {
    if (!confirmOrder) return;
    setOrders((current) => current.filter((order) => order.orderNo !== confirmOrder.orderNo));
    setConfirmOrder(null);
  };

  return (
    <div className="pickup-queue-page">
      <section className="pickup-queue-hero">
        <div>
          <p>SecondBite Vendor</p>
          <h2>Pickup Queue</h2>
          <span>Focus on today's paid orders that are waiting for customer collection.</span>
        </div>
        <button type="button" onClick={() => navigate("/vendor/orders")}>View All Orders</button>
      </section>

      <section className="pickup-queue-tools">
        <div>
          <span>Waiting Pickup</span>
          <strong>{orders.length}</strong>
        </div>
        <label>
          <span>Search</span>
          <input
            value={keyword}
            onChange={(event) => setKeyword(event.target.value)}
            placeholder="Search order no, customer, phone, or product..."
          />
        </label>
      </section>

      <section className="pickup-queue-card">
        <div className="pickup-queue-card__header">
          <div>
            <h3>Today's Pickup Orders</h3>
            <p>Static MVP UI sample. Connect API later.</p>
          </div>
        </div>

        {filteredOrders.length > 0 ? (
          <div className="pickup-queue-list">
            {filteredOrders.map((order) => (
              <article className="pickup-order-card" key={order.orderNo}>
                <div className="pickup-order-card__main">
                  <div>
                    <span className="pickup-order-card__label">Order No</span>
                    <button type="button" onClick={() => navigate(`/vendor/orders/${order.orderNo}`)}>{order.orderNo}</button>
                  </div>
                  <div>
                    <span className="pickup-order-card__label">Customer</span>
                    <strong>{order.customer} / {order.phone}</strong>
                  </div>
                  <div>
                    <span className="pickup-order-card__label">Pickup Time</span>
                    <strong>{order.pickupTime}</strong>
                  </div>
                  <div>
                    <span className="pickup-order-card__label">Total</span>
                    <strong>{order.amount}</strong>
                  </div>
                </div>

                <div className="pickup-order-card__product">
                  <span className="pickup-order-card__label">Product</span>
                  <div className="pickup-order-card__product-row">
                    <strong>{order.productName}</strong>
                    <span>Qty {order.quantity}</span>
                  </div>
                </div>

                <div className="pickup-order-card__footer">
                  <small>{order.note}</small>
                  <button type="button" onClick={() => setConfirmOrder(order)}>Mark Collected</button>
                </div>
              </article>
            ))}
          </div>
        ) : (
          <div className="pickup-queue-empty">
            <h3>No pickup orders found</h3>
            <p>Paid and collectible orders will appear here automatically.</p>
          </div>
        )}
      </section>

      {confirmOrder && (
        <div className="pickup-confirm" role="dialog" aria-modal="true">
          <button className="pickup-confirm__backdrop" type="button" aria-label="Close confirmation" onClick={() => setConfirmOrder(null)} />
          <div className="pickup-confirm__panel">
            <h3>Confirm Collection?</h3>
            <p>Please confirm the customer has collected this order.</p>
            <div className="pickup-confirm__summary">
              <span>Order</span>
              <strong>{confirmOrder.orderNo}</strong>
              <span>Customer</span>
              <strong>{confirmOrder.customer} / {confirmOrder.phone}</strong>
              <span>Product</span>
              <strong>{confirmOrder.productName} · Qty {confirmOrder.quantity}</strong>
              <span>Total</span>
              <strong>{confirmOrder.amount}</strong>
            </div>
            <div className="pickup-confirm__actions">
              <button type="button" onClick={() => setConfirmOrder(null)}>Cancel</button>
              <button type="button" onClick={handleConfirmCollected}>Confirm Collected</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PickupQueuePage;
